import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import List, { ListItem } from "material-ui/List";
import TextField from "material-ui/TextField";
import Input, { InputAdornment, InputLabel } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import Select from "material-ui/Select";
import Typography from "material-ui/Typography";
import ModalFormDialog from "./ModalFormDialog";
import InvoiceContainer from "./InvoiceContainer";
import countries from "./helpers/countries";
import states from "./helpers/states";

const styles = theme => ({
  root: {
    width: "100%"
  },
  wideListItemAction: {
    width: "70%"
  },
  secondTitle: {
    marginTop: 100
  }
});

const CreateInvoiceDialog = props => {
  const { open, onSave, onChange, onCancel, classes, data } = props;
  const { root, secondTitle } = classes;
  let isUnitedStatesSelected = false;

  let setStateFieldVisibility = function() {
    const notUnitedStatesStates = document.getElementById(
      "notUnitedStatesStates"
    );
    const unitedStatesStates = document.getElementById("unitedStatesStates");
    notUnitedStatesStates.style.display = isUnitedStatesSelected
      ? "none"
      : "block";
    unitedStatesStates.style.display = isUnitedStatesSelected
      ? "block"
      : "none";
  };

  
  const isNumberKey = event => {
    const charCode = (event.which) ? event.which : event.keyCode;
    const isNumeric = !(charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57));
    if (!isNumeric) {
      event.preventDefault();
    }
  };
  
  const isAngleBrackets = event => {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode === 62 || charCode === 60) {
      event.preventDefault();
    }
  };

  const handleChange = event => {
    let { name, value } = event.target;
    onChange({ name, value });
    if (name === "country") {
      isUnitedStatesSelected = value === "United States";
      setStateFieldVisibility();
    }
  };

  return (
    <div>
      <ModalFormDialog
        id="CreateInvoiceDialog"
        title="Invoice Options"
        open={open}
        onCancel={onCancel}
        onSave={onSave}
      >
        <List>
          <ListItem>
            <Typography type="title">Invoice Details</Typography>
          </ListItem>
          <ListItem>
            <TextField
              id="invoiceNumber"
              label="Invoice Number"
              className={classes.textField}
              margin="normal"
              fullWidth
              name="invoiceNumber"
              onChange={handleChange}
              onKeyPress={isNumberKey}
            />
          </ListItem>
          <ListItem>
            <FormControl fullWidth className={classes.formControl}>
              <InputLabel htmlFor="storageUsage">Storage</InputLabel>
              <Input
                id="storageUsage"
                name="storageUsage"
                onChange={handleChange}
                onKeyPress={isNumberKey}
                startAdornment={
                  <InputAdornment position="start">$</InputAdornment>
                }
              />
            </FormControl>
          </ListItem>
          <ListItem>
            <Typography type="title" className={secondTitle}>
              Customer Details
            </Typography>
          </ListItem>
          <ListItem>
            <TextField
              id="firstName"
              label="First Name"
              className={classes.textField}
              margin="normal"
              fullWidth
              name="firstName"
              onChange={handleChange}
              onKeyPress={isAngleBrackets}
            />
          </ListItem>
          <ListItem>
            <TextField
              id="lastName"
              label="Last Name"
              className={classes.textField}
              margin="normal"
              fullWidth
              name="lastName"
              onChange={handleChange}
              onKeyPress={isAngleBrackets}
            />
          </ListItem>
          <ListItem>
            <TextField
              id="company"
              label="Company"
              className={classes.textField}
              margin="normal"
              fullWidth
              name="company"
              onChange={handleChange}
              onKeyPress={isAngleBrackets}
            />
          </ListItem>
          <ListItem>
            <TextField
              id="address"
              label="Address"
              className={classes.textField}
              margin="normal"
              fullWidth
              name="address"
              onChange={handleChange}
              onKeyPress={isAngleBrackets}
            />
          </ListItem>
          <ListItem>
            <TextField
              id="address2"
              label="Apt, suite, etc."
              className={classes.textField}
              margin="normal"
              fullWidth
              name="address2"
              onChange={handleChange}
              onKeyPress={isAngleBrackets}
            />
          </ListItem>
          <ListItem>
            <TextField
              id="city"
              label="City"
              className={classes.textField}
              margin="normal"
              fullWidth
              name="city"
              onChange={handleChange}
              onKeyPress={isAngleBrackets}
            />
          </ListItem>
          <ListItem id="notUnitedStatesStates">
            <TextField
              id="state"
              label="State"
              className={classes.textField}
              margin="normal"
              fullWidth
              name="state"
              onChange={handleChange}
              onKeyPress={isAngleBrackets}
            />
          </ListItem>
          <ListItem id="unitedStatesStates" style={{ display: "none" }}>
            <FormControl classes={{ root }}>
              <InputLabel htmlFor="state">State</InputLabel>
              <Select onChange={handleChange} native={true} name="state">
                <option value="" key="--">
                  --
                </option>
                {Object.keys(states).map(state => (
                  <option value={states[state]} key={states[state]}>
                    {states[state]}
                  </option>
                ))}
              </Select>
            </FormControl>
          </ListItem>
          <ListItem>
            <TextField
              id="zipcode"
              label="Zip Code"
              className={classes.textField}
              margin="normal"
              fullWidth
              name="zipcode"
              onChange={handleChange}
              onKeyPress={isAngleBrackets}
            />
          </ListItem>
          <ListItem>
            <FormControl classes={{ root }}>
              <InputLabel htmlFor="country">Country</InputLabel>
              <Select name="country" native={true} onChange={handleChange}>
                <option value="" key="--" />
                {Object.keys(countries).map(country => (
                  <option value={countries[country]} key={country}>
                    {countries[country]}
                  </option>
                ))}
              </Select>
            </FormControl>
          </ListItem>
          <ListItem>
            <TextField
              id="phone"
              label="Phone"
              className={classes.textField}
              margin="normal"
              fullWidth
              name="phone"
              onChange={handleChange}
              onKeyPress={isAngleBrackets}
            />
          </ListItem>
        </List>
        <InvoiceContainer id="invoice" data={data} />
      </ModalFormDialog>
    </div>
  );
};

CreateInvoiceDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export { CreateInvoiceDialog };

export default withStyles(styles, { name: "CreateInvoiceDialog" })(
  CreateInvoiceDialog
);



// WEBPACK FOOTER //
// ./src/CreateInvoiceDialog.js